'use client'

import * as React from 'react'
import { FloatingPortal } from '@floating-ui/react'

export const popupLayerId = 'new-ui-popup-layer'
export const popupLayerZIndex = 22000

let popupLayerElement: HTMLElement | null = null
const PopupLayerContext = React.createContext<HTMLElement | null>(null)

export const getPopupLayerContainer = () => {
    if (typeof document === 'undefined') {
        return null
    }

    if (popupLayerElement?.isConnected) {
        return popupLayerElement
    }

    const existingElement = document.getElementById(popupLayerId)

    if (existingElement instanceof HTMLElement) {
        popupLayerElement = existingElement
        return popupLayerElement
    }

    if (!document.body) {
        return null
    }

    const nextElement = document.createElement('div')
    nextElement.id = popupLayerId
    nextElement.dataset.slot = 'popup-layer'
    nextElement.style.position = 'relative'
    nextElement.style.zIndex = String(popupLayerZIndex)
    document.body.appendChild(nextElement)
    popupLayerElement = nextElement

    return popupLayerElement
}

export const getPopupLayerRoot = () => getPopupLayerContainer()

export const usePopupLayerContainer = () => React.useContext(PopupLayerContext) ?? getPopupLayerContainer()

export const usePopupLayerRoot = () => React.useContext(PopupLayerContext) ?? getPopupLayerRoot()

export const PopupLayerProvider = ({
    container,
    children,
}: {
    container: HTMLElement | null
    children: React.ReactNode
}) => {
    return <PopupLayerContext.Provider value={container}>{children}</PopupLayerContext.Provider>
}

export const PopupFloatingPortal = ({ root, ...props }: React.ComponentProps<typeof FloatingPortal>) => {
    const popupLayerRoot = usePopupLayerRoot()

    return <FloatingPortal root={root ?? popupLayerRoot} {...props} />
}
